import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import BinningChecking from './checking';
import BinningStorage from './storage';
import BinningVerifyInvoice from './verifyInvoice';
import BinningLabelsReprint from './labelsReprint';
import BinningClose from './close';
import InternalOrdersList from './internalOrder/list';
import InternalOrderEdit from './internalOrder/edit';
import Invoicing from './invoicing';

export const binningRoutes = [
  {
    'component': <BinningChecking />,
    'path': paths.BinningChecking,
  },
  {
    'component': <BinningChecking />,
    'path': paths.CheckingPage,
  },
  {'component': <BinningStorage />, 'path': paths.BinningStorage},
  {'component': <BinningVerifyInvoice />, 'path': paths.BinningVerifyInvoice},
  {'component': <BinningLabelsReprint />, 'path': paths.BinningLabelsReprint},
  {'component': <BinningClose />, 'path': paths.BinningClose},
  {'component': <InternalOrdersList />, 'path': paths.InternalOrdersList},
  {'component': <InternalOrderEdit />, 'path': paths.InternalOrderEdit},
  {'component': <InternalOrderEdit />, 'path': paths.InternalOrderCreate},
  {'component': <Invoicing />, 'path': paths.Invoicing},
  {'component': <Invoicing />, 'path': paths.ManualInvoicing},
];
